// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-tsx": function componentSrcPages404Tsx() {
    return import("./../../src/pages/404.tsx"
    /* webpackChunkName: "component---src-pages-404-tsx" */
    );
  },
  "component---src-pages-business-index-tsx": function componentSrcPagesBusinessIndexTsx() {
    return import("./../../src/pages/business/index.tsx"
    /* webpackChunkName: "component---src-pages-business-index-tsx" */
    );
  },
  "component---src-pages-career-index-tsx": function componentSrcPagesCareerIndexTsx() {
    return import("./../../src/pages/career/index.tsx"
    /* webpackChunkName: "component---src-pages-career-index-tsx" */
    );
  },
  "component---src-pages-company-code-of-ethics-tsx": function componentSrcPagesCompanyCodeOfEthicsTsx() {
    return import("./../../src/pages/company/CodeOfEthics.tsx"
    /* webpackChunkName: "component---src-pages-company-code-of-ethics-tsx" */
    );
  },
  "component---src-pages-company-intellectual-property-tsx": function componentSrcPagesCompanyIntellectualPropertyTsx() {
    return import("./../../src/pages/company/intellectualProperty.tsx"
    /* webpackChunkName: "component---src-pages-company-intellectual-property-tsx" */
    );
  },
  "component---src-pages-company-milestone-tsx": function componentSrcPagesCompanyMilestoneTsx() {
    return import("./../../src/pages/company/milestone.tsx"
    /* webpackChunkName: "component---src-pages-company-milestone-tsx" */
    );
  },
  "component---src-pages-contact-index-tsx": function componentSrcPagesContactIndexTsx() {
    return import("./../../src/pages/contact/index.tsx"
    /* webpackChunkName: "component---src-pages-contact-index-tsx" */
    );
  },
  "component---src-pages-index-tsx": function componentSrcPagesIndexTsx() {
    return import("./../../src/pages/index.tsx"
    /* webpackChunkName: "component---src-pages-index-tsx" */
    );
  },
  "component---src-pages-tech-aiml-tsx": function componentSrcPagesTechAimlTsx() {
    return import("./../../src/pages/tech/aiml.tsx"
    /* webpackChunkName: "component---src-pages-tech-aiml-tsx" */
    );
  },
  "component---src-pages-tech-data-tsx": function componentSrcPagesTechDataTsx() {
    return import("./../../src/pages/tech/data.tsx"
    /* webpackChunkName: "component---src-pages-tech-data-tsx" */
    );
  },
  "component---src-pages-tech-index-tsx": function componentSrcPagesTechIndexTsx() {
    return import("./../../src/pages/tech/index.tsx"
    /* webpackChunkName: "component---src-pages-tech-index-tsx" */
    );
  },
  "component---src-pages-tech-webrtc-tsx": function componentSrcPagesTechWebrtcTsx() {
    return import("./../../src/pages/tech/webrtc.tsx"
    /* webpackChunkName: "component---src-pages-tech-webrtc-tsx" */
    );
  },
  "component---src-templates-ir-list-tsx": function componentSrcTemplatesIrListTsx() {
    return import("./../../src/templates/irList.tsx"
    /* webpackChunkName: "component---src-templates-ir-list-tsx" */
    );
  },
  "component---src-templates-ir-post-tsx": function componentSrcTemplatesIrPostTsx() {
    return import("./../../src/templates/irPost.tsx"
    /* webpackChunkName: "component---src-templates-ir-post-tsx" */
    );
  },
  "component---src-templates-news-list-tsx": function componentSrcTemplatesNewsListTsx() {
    return import("./../../src/templates/newsList.tsx"
    /* webpackChunkName: "component---src-templates-news-list-tsx" */
    );
  },
  "component---src-templates-news-post-tsx": function componentSrcTemplatesNewsPostTsx() {
    return import("./../../src/templates/newsPost.tsx"
    /* webpackChunkName: "component---src-templates-news-post-tsx" */
    );
  }
};